var _path, _path2, _path3, _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeaSmallIcon06(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_743_3706)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8139 15.0004C19.8945 15.0004 20.7704 14.1244 20.7704 13.0439C20.7704 11.9634 19.8945 11.0874 18.8139 11.0874C17.7334 11.0874 16.8574 11.9634 16.8574 13.0439C16.8574 14.1244 17.7334 15.0004 18.8139 15.0004Z",
    fill: "url(#paint0_linear_743_3706)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6648 17.194C14.7271 17.2542 14.7768 17.3261 14.811 17.4057C14.8451 17.4852 14.8631 17.5708 14.8639 17.6574C14.8646 17.744 14.8481 17.8299 14.8153 17.91C14.7826 17.9902 14.7341 18.063 14.6729 18.1242C14.6117 18.1855 14.5388 18.2339 14.4587 18.2667C14.3785 18.2995 14.2927 18.316 14.2061 18.3152C14.1195 18.3145 14.0339 18.2965 13.9543 18.2623C13.8748 18.2281 13.8028 18.1784 13.7427 18.1162C12.3974 16.7708 11.6416 14.9462 11.6416 13.0436C11.6416 11.1411 12.3974 9.31641 13.7427 7.97107C13.8028 7.90878 13.8748 7.8591 13.9543 7.82492C14.0339 7.79074 14.1195 7.77275 14.2061 7.772C14.2927 7.77124 14.3785 7.78775 14.4587 7.82054C14.5388 7.85333 14.6117 7.90175 14.6729 7.96299C14.7341 8.02422 14.7826 8.09704 14.8153 8.17718C14.8481 8.25733 14.8646 8.34321 14.8639 8.4298C14.8631 8.5164 14.8451 8.60198 14.811 8.68154C14.7768 8.76111 14.7271 8.83307 14.6648 8.89323C14.1198 9.43827 13.6874 10.0853 13.3924 10.7974C13.0975 11.5096 12.9457 12.2728 12.9457 13.0436C12.9457 13.8144 13.0975 14.5777 13.3924 15.2898C13.6874 16.0019 14.1198 16.649 14.6648 17.194ZM23.8877 18.1162C23.7647 18.2349 23.6 18.3007 23.429 18.2992C23.258 18.2977 23.0944 18.2291 22.9735 18.1082C22.8526 17.9873 22.784 17.8237 22.7825 17.6527C22.781 17.4817 22.8468 17.317 22.9656 17.194C23.5106 16.649 23.943 16.0019 24.2379 15.2898C24.5329 14.5777 24.6847 13.8144 24.6847 13.0436C24.6847 12.2728 24.5329 11.5096 24.2379 10.7974C23.943 10.0853 23.5106 9.43827 22.9656 8.89323C22.9033 8.83307 22.8536 8.76111 22.8194 8.68154C22.7852 8.60198 22.7672 8.5164 22.7665 8.4298C22.7657 8.34321 22.7822 8.25733 22.815 8.17718C22.8478 8.09704 22.8963 8.02422 22.9575 7.96299C23.0187 7.90175 23.0915 7.85333 23.1717 7.82054C23.2518 7.78775 23.3377 7.77124 23.4243 7.772C23.5109 7.77275 23.5965 7.79074 23.676 7.82492C23.7556 7.8591 23.8276 7.90878 23.8877 7.97107C25.233 9.31641 25.9888 11.1411 25.9888 13.0436C25.9888 14.9462 25.233 16.7708 23.8877 18.1162Z",
    fill: "url(#paint1_linear_743_3706)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9883 30.0001H19.6288L19.4664 16.2395C20.2582 16.0778 20.9617 15.628 21.4407 14.9771C21.9196 14.3263 22.1398 13.5208 22.0586 12.7168C21.9774 11.9128 21.6005 11.1676 21.0011 10.6257C20.4016 10.0837 19.6223 9.78369 18.8143 9.78369C18.0062 9.78369 17.2269 10.0837 16.6275 10.6257C16.028 11.1676 15.6512 11.9128 15.5699 12.7168C15.4887 13.5208 15.7089 14.3263 16.1879 14.9771C16.6668 15.628 17.3703 16.0778 18.1621 16.2395V22.8263C18.1599 24.7283 17.4033 26.5516 16.0585 27.8965C14.7136 29.2414 12.8902 29.9979 10.9883 30.0001Z",
    fill: "url(#paint2_linear_743_3706)"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: -11.249,
    y: -12,
    width: 52.4988,
    height: 54
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(6px)",
      clipPath: "url(#bgblur_1_743_3706_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_743_3706)",
    "data-figma-bg-blur-radius": 12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7276 30C23.0736 30 23.4053 29.8626 23.6499 29.618C23.8945 29.3734 24.032 29.0416 24.032 28.6957V23.4607C26.2565 21.7941 27.8899 19.4597 28.6934 16.7987C29.497 14.1377 29.4286 11.2895 28.4983 8.67013C27.568 6.05076 25.8245 3.79749 23.5225 2.23947C21.2205 0.681445 18.4807 -0.0996833 15.7032 0.0101883C8.64478 0.276272 3.16268 6.30032 3.16268 13.3639V14.2117L0.86315 19.3834C0.727033 19.6901 0.714311 20.0374 0.827628 20.3531C0.940946 20.6689 1.17159 20.9289 1.47162 21.079L3.16268 21.9249V26.7392C3.16268 27.604 3.50623 28.4334 4.11776 29.0449C4.72928 29.6565 5.55869 30 6.42351 30H22.7276Z",
    fill: "url(#paint3_linear_743_3706)",
    fillOpacity: 0.53
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7276 30C23.0736 30 23.4053 29.8626 23.6499 29.618C23.8945 29.3734 24.032 29.0416 24.032 28.6957V23.4607C26.2565 21.7941 27.8899 19.4597 28.6934 16.7987C29.497 14.1377 29.4286 11.2895 28.4983 8.67013C27.568 6.05076 25.8245 3.79749 23.5225 2.23947C21.2205 0.681445 18.4807 -0.0996833 15.7032 0.0101883C8.64478 0.276272 3.16268 6.30032 3.16268 13.3639V14.2117L0.86315 19.3834C0.727033 19.6901 0.714311 20.0374 0.827628 20.3531C0.940946 20.6689 1.17159 20.9289 1.47162 21.079L3.16268 21.9249V26.7392C3.16268 27.604 3.50623 28.4334 4.11776 29.0449C4.72928 29.6565 5.55869 30 6.42351 30H22.7276Z",
    fill: "url(#paint4_linear_743_3706)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.66309 21.6162L3.38672 21.4775L1.69531 20.6318C1.51037 20.5393 1.36774 20.3792 1.29785 20.1846C1.22803 19.99 1.23658 19.7759 1.32031 19.5869L3.61914 14.415L3.66309 14.3184V13.3643C3.66309 6.55335 8.948 0.765292 15.7217 0.509766H15.7227C18.3935 0.404112 21.0286 1.15515 23.2422 2.65332C25.4559 4.15156 27.1327 6.31902 28.0273 8.83789C28.9218 11.3566 28.9875 14.0955 28.2148 16.6543C27.4421 19.2131 25.8715 21.4578 23.7324 23.0605L23.5322 23.2109V28.6953C23.5322 28.9086 23.4467 29.1138 23.2959 29.2646C23.1451 29.4153 22.9407 29.5 22.7275 29.5H6.42383C5.69171 29.5 4.98942 29.209 4.47168 28.6914C3.95394 28.1737 3.66311 27.4714 3.66309 26.7393V21.6162Z",
    stroke: "url(#paint5_linear_743_3706)",
    strokeOpacity: 0.1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_743_3706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6648 17.1935C14.7271 17.2537 14.7768 17.3256 14.811 17.4052C14.8451 17.4848 14.8631 17.5703 14.8639 17.6569C14.8646 17.7435 14.8481 17.8294 14.8153 17.9096C14.7826 17.9897 14.7341 18.0625 14.6729 18.1237C14.6117 18.185 14.5388 18.2334 14.4587 18.2662C14.3785 18.299 14.2927 18.3155 14.2061 18.3147C14.1195 18.314 14.0339 18.296 13.9543 18.2618C13.8748 18.2276 13.8028 18.178 13.7427 18.1157C12.3974 16.7703 11.6416 14.9457 11.6416 13.0431C11.6416 11.1406 12.3974 9.31592 13.7427 7.97058C13.8028 7.90829 13.8748 7.85861 13.9543 7.82443C14.0339 7.79025 14.1195 7.77226 14.2061 7.77151C14.2927 7.77076 14.3785 7.78726 14.4587 7.82005C14.5388 7.85284 14.6117 7.90127 14.6729 7.9625C14.7341 8.02373 14.7826 8.09655 14.8153 8.1767C14.8481 8.25685 14.8646 8.34272 14.8639 8.42932C14.8631 8.51591 14.8451 8.60149 14.811 8.68105C14.7768 8.76062 14.7271 8.83258 14.6648 8.89274C14.1198 9.43778 13.6874 10.0848 13.3924 10.797C13.0975 11.5091 12.9457 12.2723 12.9457 13.0431C12.9457 13.8139 13.0975 14.5772 13.3924 15.2893C13.6874 16.0014 14.1198 16.6485 14.6648 17.1935ZM23.8877 18.1157C23.7647 18.2345 23.6 18.3002 23.429 18.2987C23.258 18.2972 23.0944 18.2286 22.9735 18.1077C22.8526 17.9868 22.784 17.8232 22.7825 17.6522C22.781 17.4812 22.8468 17.3165 22.9656 17.1935C23.5106 16.6485 23.943 16.0014 24.2379 15.2893C24.5329 14.5772 24.6847 13.8139 24.6847 13.0431C24.6847 12.2723 24.5329 11.5091 24.2379 10.797C23.943 10.0848 23.5106 9.43778 22.9656 8.89274C22.9033 8.83258 22.8536 8.76062 22.8194 8.68105C22.7852 8.60149 22.7672 8.51591 22.7665 8.42932C22.7657 8.34272 22.7822 8.25685 22.815 8.1767C22.8478 8.09655 22.8963 8.02373 22.9575 7.9625C23.0187 7.90127 23.0915 7.85284 23.1717 7.82005C23.2518 7.78726 23.3377 7.77076 23.4243 7.77151C23.5109 7.77226 23.5965 7.79025 23.676 7.82443C23.7556 7.85861 23.8276 7.90829 23.8877 7.97058C25.233 9.31592 25.9888 11.1406 25.9888 13.0431C25.9888 14.9457 25.233 16.7703 23.8877 18.1157Z",
    fill: "#A5A7B4"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_743_3706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9873 30.0006H19.6278L19.4655 16.2399C20.2572 16.0783 20.9608 15.6285 21.4397 14.9776C21.9186 14.3268 22.1388 13.5213 22.0576 12.7173C21.9764 11.9133 21.5995 11.1681 21.0001 10.6262C20.4007 10.0842 19.6214 9.78418 18.8133 9.78418C18.0052 9.78418 17.2259 10.0842 16.6265 10.6262C16.027 11.1681 15.6502 11.9133 15.569 12.7173C15.4878 13.5213 15.708 14.3268 16.1869 14.9776C16.6658 15.6285 17.3694 16.0783 18.1611 16.2399V22.8268C18.1589 24.7287 17.4023 26.5521 16.0575 27.897C14.7126 29.2419 12.8892 29.9984 10.9873 30.0006Z",
    fill: "url(#paint6_linear_743_3706)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_743_3706",
    x: -11.249,
    y: -12,
    width: 52.4988,
    height: 54,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_743_3706"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_743_3706_clip_path",
    transform: "translate(11.249 12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7276 30C23.0736 30 23.4053 29.8626 23.6499 29.618C23.8945 29.3734 24.032 29.0416 24.032 28.6957V23.4607C26.2565 21.7941 27.8899 19.4597 28.6934 16.7987C29.497 14.1377 29.4286 11.2895 28.4983 8.67013C27.568 6.05076 25.8245 3.79749 23.5225 2.23947C21.2205 0.681445 18.4807 -0.0996833 15.7032 0.0101883C8.64478 0.276272 3.16268 6.30032 3.16268 13.3639V14.2117L0.86315 19.3834C0.727033 19.6901 0.714311 20.0374 0.827628 20.3531C0.940946 20.6689 1.17159 20.9289 1.47162 21.079L3.16268 21.9249V26.7392C3.16268 27.604 3.50623 28.4334 4.11776 29.0449C4.72928 29.6565 5.55869 30 6.42351 30H22.7276Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_743_3706",
    x: 11.6416,
    y: 7.77148,
    width: 14.3472,
    height: 12.5433,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_743_3706"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_743_3706",
    x: 10.9873,
    y: 9.78418,
    width: 11.0869,
    height: 22.2164,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_743_3706"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_743_3706",
    x1: 16.8574,
    y1: 11.0874,
    x2: 21.4668,
    y2: 12.2578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FF97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2C32FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_743_3706",
    x1: 11.6416,
    y1: 7.77197,
    x2: 27.713,
    y2: 13.3251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FF97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2C32FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_743_3706",
    x1: 10.9883,
    y1: 9.78369,
    x2: 24.6258,
    y2: 11.6827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FF97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2C32FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_743_3706",
    x1: 15.0004,
    y1: 0,
    x2: 15.0004,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FF97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C32FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_743_3706",
    x1: 0.750977,
    y1: 0,
    x2: 34.5213,
    y2: 8.14584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776042,
    stopColor: "#5C6DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_743_3706",
    x1: 1.64157,
    y1: 1.36364,
    x2: 29.2498,
    y2: 1.36364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#364AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_743_3706",
    x1: 16.5307,
    y1: 30.0006,
    x2: 22.4999,
    y2: 3.21436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C32FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FF97"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_743_3706"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaSmallIcon06);
export default __webpack_public_path__ + "static/media/fea-small-icon06.4fe56ebd7c12ca66af362d82e1ae54dd.svg";
export { ForwardRef as ReactComponent };